import { Schema as S } from "effect";
const StatusConfigured = S.Struct({
    status: S.Literal("configured"),
    placeholder: S.NullOr(S.String)
});
const StatusErrored = S.Struct({
    status: S.Literal("errored")
});
const StatusValidating = S.Struct({
    status: S.Literal("validating"),
    // When we expect the validation to be completed by
    expectedValidatedBy: S.DateFromString
});
const StatusMissing = S.Struct({
    status: S.Literal("missing")
});
export const Schema = S.Union(StatusConfigured, StatusErrored, StatusValidating, StatusMissing);
